<template>
  <el-dialog
    :title="'上传' + (isUploadVideo ? '视频' : '图片')"
    :visible="hmUploadVisible"
    @close="cancleUpload"
  >
    <div class="mb20">
      <el-upload
        class="upload"
        ref="upload"
        :limit="1"
        drag
        :data="{ fileDir: isUploadVideo ? videoDir : fileDir }"
        :headers="{ 'X-Access-Token': $token }"
        :action="isUploadVideo ? $uploadVideoUrl : $uploadUrl"
        :on-remove="handleRemove"
        :onError="uploadError"
        :onSuccess="uploadSuccess"
        :beforeUpload="beforeUpload"
        :onProgress="uploading"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将{{ isUploadVideo ? "视频" : "图片" }}拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
    </div>
    <div class="btn-wrapper flex flex-center">
      <el-button
        size="small"
        type="primary"
        @click="saveUploadedImg"
        :disabled="!uploadImg"
        >保存</el-button
      >
      <el-button size="small" @click="cancleUpload">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    maxUploadSize: {
      type: [String, Number],
      default: "10"
    },
    hmUploadVisible: {
      type: Boolean,
      default: false
    },
    fileDir: {
      type: String,
      default: ""
    },
    isUploadVideo: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      uploadImg: "",
      isSaving: false,
      videoDir: "video"
    };
  },
  computed: {},
  watch: {
    hmUploadVisible(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.upload.clearFiles();
          this.uploadImg = "";
        }, 0);
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    saveUploadedImg() {
      this.$emit("hmUploadSuccess", this.uploadImg);
    },
    cancleUpload() {
      this.$emit("cancleUpload", this.uploadImg);
    },
    handleRemove() {
      this.uploadImg = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.uploadImg = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      return this.isUploadVideo ? this.checkVideo(file) : this.checkImg(file);
    },
    checkVideo(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "avi";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "mp4";
      console.log("extension: ", extension);
      console.log("extension2: ", extension2);
      // file.size单位为b，除以1024得到kb 再除以1024得到mb
      const limitSize = file.size / 1024 / 1024 <= this.maxUploadSize;
      if (!extension && !extension2) {
        this.$message({
          message: "上传模板只能是 mp4、avi格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: `上传模板大小不能超过 ${this.maxUploadSize}M!`,
          type: "warning"
        });
      }
      return (extension || extension2) && limitSize;
    },
    checkImg(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 / 1024 <= 3;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 3M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
